import { useEffect } from "react";

import { LoginAnalyticsPageView } from "@/constants/analytics/Login";
import { LoginTestID } from "@/constants/TestID";
import { useAnalytics } from "@/services/Analytics";
import ForgotPasswordForm from "@/ui/components/authentication/ForgotPasswordForm";
import LoginScreenContainer from "@/ui/components/authentication/LoginScreenContainer";
import LoginScreenContent from "@/ui/components/authentication/LoginScreenContent";
import AppVersionLabel from "@/ui/components/common/AppVersionLabel";

const Screen = () => {
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(LoginAnalyticsPageView.ForgotPassword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginScreenContainer testID={LoginTestID.ForgotPassword}>
      <LoginScreenContent
        subtitle="Enter your email address below, and we'll send you a link to reset your password."
        testID={LoginTestID.ForgotPassword}
        title="Recover your password"
      >
        <ForgotPasswordForm />
      </LoginScreenContent>

      <AppVersionLabel testID={LoginTestID.Login} />
    </LoginScreenContainer>
  );
};

// eslint-disable-next-line import-x/no-unused-modules -- File is used by expo-router file based navigation but TypeScript can not infer its usage
export default Screen;
